import { Navigate, useSearchParams } from 'react-router-dom';

export function InfoPage() {
  const [searchParams] = useSearchParams();
  const rawId = searchParams.get('hinkid') ?? searchParams.get('containerId') ?? '';
  const containerId = Number.parseInt(rawId, 10);

  if (Number.isFinite(containerId) && containerId > 0) {
    return <Navigate to={`/info/${containerId}`} replace />;
  }

  return (
    <div className="mx-auto max-w-xl rounded-3xl border border-gray-200 bg-white px-6 py-8 text-center shadow-sm">
      <h1 className="text-xl font-semibold text-gray-900">Spårbar batchinformation</h1>
      <p className="mt-3 text-sm text-gray-600">
        Ange ett giltigt hink-ID i länken, till exempel <span className="font-medium text-gray-900">/info/205</span> eller
        <span className="font-medium text-gray-900"> /info?hinkid=205</span>.
      </p>
    </div>
  );
}
